import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const getPageTitle = (pathname) => {
      // Remove leading slash and split by '/'
      const path = pathname.replace(/^\//, '');
      const segments = path.split('/');
      
      // Map route paths to page titles
      const titleMap = {
        '': 'Login',
        'dashboard': 'Dashboard',
        'itemmaster': 'Item Master',
        'repairs': 'Repairs',
        'repairstable': 'Repairs Table',
        'urd_purchase': 'URD Purchase',
        'itemmastertable': 'Item Master Table',
        'estimates': 'Estimates',
        'estimatetable': 'Estimate Table',
        'suppliertable': 'Supplier Table',
        'customerstable': 'Customers Table',
        'customermaster': 'Customer Master',
        'suppliermaster': 'Supplier Master',
        'workermaster': 'Worker Master',
        'workerstable': 'Worker Table',
        'stockEntry': 'Stock Entry',
        'stockEntryTable': 'Stock Entry Table',
        'purchase': 'Purchase',
        'purchasetable': 'Purchase Table',
        'purchasetableold': 'Purchase Table (Old)',
        'receipts': 'Receipts',
        'orderreceipts': 'Order Receipts',
        'receiptstable': 'Receipts Table',
        'purchaseReport': 'Purchase Report',
        'purchaseBalanceReport': 'Purchase Balance Report',
        'salesReport': 'Sales Report',
        'salesBalanceReport': 'Sales Balance Report',
        'estimateReport': 'Estimate Report',
        'repairsReport': 'Repairs Report',
        'urdPurchaseReport': 'URD Purchase Report',
        'payments': 'Payments',
        'paymentstable': 'Payments Table',
        'accounts': 'Accounts',
        'accountstable': 'Accounts Table',
        'sales': 'Sales',
        'sales2': 'Sales',
        'metaltype': 'Metal Type',
        'purity': 'Purity',
        'rates': 'Rates',
        'ratesdata': 'Rates Data',
        'company_info': 'Company Info',
        'designmaster': 'Design Master',
        'salestable': 'Sales Table',
        'urdpurchasetable': 'URD Purchase Table',
        'puritytable': 'Purity Table',
        'orderstable': 'Orders Table',
        'orders': 'Orders',
        'barcodeprinting': 'Barcode Printing',
        'salesNew': 'Sales (New)',
        'salesreturn': 'Sales Return',
        'estimatereceipt': 'Estimate Receipt',
        'accountdetails': 'Account Details',
        'receivables': 'Receivables',
        'usermaster': 'User Master',
        'usertable': 'User Table',
        'subcategory': 'Sub Category',
        'subcategorytable': 'Sub Category Table',
        'festoffers': 'Festival Offers',
        'festofferstable': 'Festival Offers Table',
        'estimateSales': 'Estimate Sales',
        'qrcode': 'QR Code Scanner',
        'purchase-payment': 'Purchase Payment',
        'ratecuts': 'Rate Cuts',
        'itemsales': 'Item Sales'
      };

      // Get the first segment of the path
      const firstSegment = segments[0];
      
      // Check if we have a direct match
      if (titleMap[firstSegment]) {
        return `SadaShri | ${titleMap[firstSegment]}`;
      }

      // Handle dynamic routes (like /sales/details/:invoice_number)
      if (firstSegment === 'sales' && segments[1] === 'details') {
        return 'SadaShri | Sales Details';
      }

      // Handle routes with IDs
      if (segments.length > 1 && segments[1] && !isNaN(segments[1])) {
        const baseTitle = titleMap[firstSegment];
        if (baseTitle) {
          return `SadaShri | ${baseTitle} (Edit)`;
        }
      }

      // Default fallback
      return 'SadaShri | Jewel Kart ERP';
    };

    const newTitle = getPageTitle(location.pathname);
    document.title = newTitle;
  }, [location.pathname]);
};

export default usePageTitle; 